module.exports = __webpack_public_path__ + "static/media/recycled.17b57f5c.png";